import React from 'react';
import { motion } from 'framer-motion';

export default function About() {
  const containerVariants = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.3, delayChildren: 0.2 } },
  };
  const itemVariants = {
    hidden: { opacity: 0, x: -50 },
    visible: { opacity: 1, x: 0, transition: { type: 'spring', stiffness: 80 } },
  };

  return (
    <section
      id="about"
      className="min-h-screen flex flex-col justify-center items-center bg-gradient-to-tr from-purple-50 to-indigo-50 px-6 md:px-20 py-20"
    >
      <motion.div
        className="max-w-4xl text-center md:text-left"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        <motion.h2 className="text-4xl font-bold mb-6 text-indigo-900" variants={itemVariants}>
          About Me
        </motion.h2>
        <motion.p className="text-lg text-gray-700 mb-6" variants={itemVariants}>
        Hi! I’m Bereket, a recent Computer Science graduate from Hawassa University with distiniction, and a passionate frontend developer, graphic designer, and future-ready IT professional.
        </motion.p>
        <motion.p className="text-lg text-gray-700 mb-6" variants={itemVariants}>
        Over the past few years, I've built a strong foundation in web development, network systems, and digital design, and I’m always looking for new ways to merge technology with creativity to solve real-world problems.
        </motion.p>
        <motion.p className="text-lg text-gray-700 mb-6" variants={itemVariants}>
        💻 My Journey So Far:
        </motion.p>
        <motion.p className="text-lg text-gray-700 mb-6" variants={itemVariants}>
        🎓 Graduated with a BSc in Computer Science, where I developed a range of technical skills and a problem-solving mindset.

📱 Designed and developed a Maternal Health Surveillance Mobile Application for my final year project—a tech solution aimed at improving maternal care and health tracking in local communities.

🏦 Completed a hands-on internship at Nib International Bank, where I was involved in network installation, configuration, and IT infrastructure setup—experiencing firsthand the critical role of technology in enterprise environments.
        </motion.p>
        <motion.p className="text-lg text-gray-700 mb-6" variants={itemVariants}>
        🛠️ What I Do:
        </motion.p>
        <motion.p className="text-lg text-gray-700 mb-6" variants={itemVariants}>
        As a Frontend Web Developer, I specialize in building responsive, elegant, and user-friendly websites using modern tools like HTML, CSS, JavaScript, and frameworks like React. I focus on performance, clean design, and accessibility to ensure every project I work on is both beautiful and functional.
        </motion.p>
        <motion.p className="text-lg text-gray-700 mb-6" variants={itemVariants}>
        As a future-focused IT Officer, I bring skills in:
        </motion.p>
        <motion.p className="text-lg text-gray-700 mb-6" variants={itemVariants}>
        🔧 Network installation & troubleshooting

🛡️ System maintenance & data security

🖥️ Hardware & software support

📊 Technical documentation & user training

🔍 Problem analysis and critical thinking
        </motion.p>
        <motion.p className="text-lg text-gray-700 mb-6" variants={itemVariants}>
        🎨 On the Creative Side:
        </motion.p> <motion.p className="text-lg text-gray-700 mb-6" variants={itemVariants}>
        I’m also a skilled Graphic Designer, known for creating eye-catching YouTube thumbnails, social media graphics, and branding assets that stand out and drive engagement. My designs blend visual impact with purpose, helping creators and businesses tell their story.
        </motion.p> <motion.p className="text-lg text-gray-700 mb-6" variants={itemVariants}>
        Let’s Build the Future Together
        </motion.p> <motion.p className="text-lg text-gray-700 mb-6" variants={itemVariants}>
        Whether you’re a startup needing a high-quality website, a company looking for reliable IT support, or a content creator in need of killer graphics—I’m here to help you bring your vision to life.

Let’s connect and create something truly exceptional.
        </motion.p>
        <motion.ul className="flex justify-center md:justify-start space-x-8 text-indigo-600" variants={itemVariants}>
          <li className="hover:text-indigo-900 transition cursor-default select-none">
            💻 Coding & Development
          </li>
          <li className="hover:text-indigo-900 transition cursor-default select-none">
            🎨 Graphic Design
          </li>
          <li className="hover:text-indigo-900 transition cursor-default select-none">
            📺 YouTube Thumbnails
          </li>
        </motion.ul>
      </motion.div>
    </section>
  );
}
